import store, { RootState } from "@invesco/shared/store/index";
import crashlytics from "@react-native-firebase/crashlytics";
import Constants from "expo-constants";
import { Platform } from "react-native";

const isNative = Platform.OS === "android" || Platform.OS === "ios";

let originalHandler: any = undefined;

async function initCrashlytics() {
  if (!isNative) return;
  try {
    const pan = (store?.getState?.() as RootState)?.user?.pan;
    const appVersion = Constants?.expoConfig?.version || "-";
    const platform = Platform.OS;
    await crashlytics().setCrashlyticsCollectionEnabled(true);
    // Set user and app context early
    try {
      if (pan) await crashlytics().setUserId(String(pan));
      await crashlytics().setAttributes({
        pan: pan || "-",
        platform,
        app_version: appVersion,
      });
    } catch (e) {
      console.error("[Crashlytics] Error setting attributes", e);
    }
    if (typeof (global as any).ErrorUtils?.getGlobalHandler === "function") {
      originalHandler = (global as any).ErrorUtils.getGlobalHandler();
    }
    if (typeof (global as any).ErrorUtils?.setGlobalHandler === "function") {
      (global as any).ErrorUtils.setGlobalHandler((error: any, isFatal?: boolean) => {
        try {
          crashlytics().recordError(error);
          crashlytics().log(`[JS Exception] fatal=${!!isFatal}`);
          crashlytics().setAttributes({
            pan: pan || "-",
            last_js_exception: String(error?.message || error) || "-",
            last_js_exception_fatal: String(!!isFatal),
          });
        } catch (e) {
          console.error("[Crashlytics] Error setting attributes", e);
        }
        if (originalHandler) {
          try {
            originalHandler(error, isFatal);
          } catch (e) {
            console.error("[Crashlytics] original handler failed", e);
          }
        }
      });
    }
  } catch (e) {
    console.warn("[Crashlytics] init failed", e);
  }
}

export default initCrashlytics;
